module.exports = __webpack_public_path__ + "media/images/company/cp13-5d69b63285e02f9e9692202c19858fb1.png";